












import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
import { AppGetterTypes } from "../store";
import { IPromotionModel } from "../models";

@Component
export default class Logo extends Vue {
    @Getter(AppGetterTypes.promotion)
    promotion!: IPromotionModel;

    get imgAltText(): string {
        return this.promotion.brand + " Logo";
    }
}
